import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import DetailPage from 'containers/expertise/DetailPage';
import {
  commitmentToSafety,
  comprehensiveFiberSolutions,
  construction,
  engineeringExpertise,
  maintenanceRestoration,
  oSPConstruction,
  precisionSplicingActivation,
  wirelineHero,
} from '../../images/expertise/wireline';

const Communication: NextPage = () => {
  return (
    <>
      <Header
        title="Wireline"
        description="At Utilities One, we focus on delivering high-quality fiber solutions to power modern communications. From rapid provisioning to seamless installations, our wireline services are designed with reliability, security, and efficiency in mind, adhering to the highest industry standards."
        image={wirelineHero}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: oSPConstruction,
            id: 'ospConstruction',
            title: 'OSP Construction',
            hasListItems: true,
            description:
              'Deployment of external network infrastructure to enable seamless communication and connectivity. Our team specializes in advanced methods and tools to ensure efficient installations.',
            listItems: [
              { boldText: 'Aerial fiber and copper installations for robust and scalable networks.' },
              { boldText: 'Pole maintenance to enhance infrastructure durability and safety.' },
              { boldText: 'Trenching and horizontal directional drilling for underground cabling and secure deployments.' },
            ],
          },
          {
            bgImage: construction,
            id: 'ispConstruction',
            title: 'ISP Construction',
            hasListItems: true,
            description:
              'Comprehensive internal network solutions designed to optimize performance and reliability within facilities. Our services support the evolving demands of modern telecommunications.',
            listItems: [
              { boldText: 'Voice and data network installations tailored for diverse environments.' },
              { boldText: 'Equipment configuration to ensure seamless integration with existing systems.' },
              { boldText: 'Full-scale integration services to connect networks efficiently.' },
            ],
          },
          {
            bgImage: engineeringExpertise,
            id: 'engineeringExpertise',
            title: 'Engineering Expertise',
            hasListItems: true,
            description:
              'Our in-house engineering team delivers efficient and scalable network designs to meet diverse project needs.',
            listItems: [
              {
                boldText: 'Advanced Network Design uses GIS tools to optimize layouts for performance.',
              },
              {
                boldText:
                  'Structural Engineering ensures durability with pole load analysis, foundation design, and safety assessments.',
              },
              {
                boldText: 'Regulatory Compliance secures permits and ensures adherence to all regulations.',
              },
              {
                boldText: 'Capacity Planning prepares networks for current demands and future growth.',
              },
            ],
          },
          {
            bgImage: comprehensiveFiberSolutions,
            id: 'comprehensiveFiberSolutions',
            title: 'Comprehensive Fiber Solutions',
            hasListItems: true,
            description:
              'Advanced fiber optic services to meet the increasing demand for high-speed connectivity. We deliver innovative and scalable solutions for a variety of settings.',
            listItems: [
              { boldText: 'FTTH installations for direct, high-speed home internet access.' },
              { boldText: 'Scalable FTTX infrastructure to accommodate growing connectivity needs.' },
              { boldText: 'Micro-trenching for minimal disruption and efficient deployments.' },
              { boldText: 'Advanced network planning for optimized and future-ready infrastructure.' },
            ],
          },
          {
            bgImage: maintenanceRestoration,
            id: 'maintenanceRestoration',
            title: 'Maintenance & Restoration',
            hasListItems: true,
            description:
              'Proactive and responsive services to keep your network running with minimal downtime. We are dedicated to maintaining operational excellence.',
            listItems: [
              { boldText: 'Routine maintenance services to prevent disruptions and extend infrastructure lifespan.' },
              { boldText: 'Rapid restoration to minimize impact during outages and emergencies.' },
              { boldText: '24/7 support to ensure smooth network operations at all times.' },
            ],
          },
          {
            bgImage: precisionSplicingActivation,
            id: 'precisionSplicingActivation',
            title: 'Precision Splicing & Activation',
            hasListItems: true,
            description:
              'Expert splicing and activation services ensure reliable network performance and seamless functionality.',
            listItems: [
              { boldText: 'Advanced fiber and copper splicing techniques for durable connections.' },
              { boldText: 'Rigorous system testing to identify and address potential issues.' },
              { boldText: 'Activation processes optimized for immediate and efficient operations.' },
            ],
          },
          {
            bgImage: commitmentToSafety,
            id: 'commitmentToSafety',
            title: 'Commitment to Safety',
            hasListItems: true,
            description:
              'Our projects adhere to the highest safety standards to ensure the well-being of our team and the communities we serve. We maintain strict quality assurance protocols to deliver excellence.',
            listItems: [
              { boldText: 'Compliance with utility, municipal, and state construction codes.' },
              { boldText: 'Implementation of cutting-edge safety practices across all projects.' },
              { boldText: 'Regular training to uphold industry-leading safety standards.' },
            ],
          },
        ]}
      />
    </>
  );
};

export default Communication;
